import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const errorToast = (message, position = 'top-right') => {
  const MySwal = withReactContent(Swal);

  const Toast = Swal.mixin({
    toast: true,
    position,
    showConfirmButton: false,
    timer: 3000
  });

  Toast.fire({
    icon: 'error',
    title: message
  });

  return MySwal;
};

export const expiredLoginToast = (title) => {
  Swal.fire({
    title,
    icon: 'warning',
    html: 'Please login again',
    showCloseButton: true,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText: '<a href="/login">Login now</a>',
    cancelButtonText: 'Later',
  });
};

export const successToast = (message, position) => {
  const MySwal = withReactContent(Swal);

  const Toast = Swal.mixin({
    toast: true,
    position,
    showConfirmButton: false,
    timer: 3000
  });

  Toast.fire({
    icon: 'success',
    title: message
  });

  return MySwal;
};
